<template>
	<div class="noInfo"
	     :style="{ padding }"
	>
		<div class="icon">
			<svg-sprite icon-id="icon-info" width="120" height="120"></svg-sprite>
		</div>
		<div class="text">{{ text }}</div>
	</div>
</template>

<script>
export default {
	name: "NoInfo",
	props: {
		text: {
			type: String,
			default: "Unfortunately, there is no information here yet.",
		},
		padding: {
			type: String,
			default: '10vw'
		},
	},
};
</script>

<style scoped lang="scss">
.noInfo {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 1vw;
	font-size: 22px;
	text-align: center;
}
</style>
